import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Card = styled.figure`
  --card-height: 300px;
  --image-height: 210px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--clr-bg-2-text);
  background-color: var(--clr-bg-2);
  height: var(--card-height);
  cursor: pointer;
  
  &:hover {
    img {
      filter: saturate(2.8) drop-shadow(0px 1px 3px #2b2b2b);
    }
  }
  
`
const DeviceName = styled.figcaption`
  font-size: var(--h6);
  width: 150px;
  font-weight: 700;
  min-height: 25px;
  word-wrap: break-word;
  text-align: center;
`
const DeviceSubName = styled(DeviceName)`
  font-weight: unset;
`
const Image = styled.img`
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: var(--image-height);
`

/**
 * This function takes in an image URL, an onClick function, an alt tag, a name, and a sub name, and
 * returns a card with an image and a title
 * @param {{
 *   imgURL: string,
 *   onClick: function,
 *   altTag: string,
 *   name: string,
 *   subName: string
 * }}
 * @return {React.ReactNode}
 */

const DeviceCard = ({ imgURL, onClick, altTag, deviceName, subName }) => {
  const aName = deviceName || ''
  const aSubName = subName ? `(${subName})` : ''
  return (
    <Card onClick={onClick} className="device-select-modal-btn borderless">
      <div>
        <DeviceName>{aName}</DeviceName>
        <DeviceSubName>{aSubName}</DeviceSubName>
      </div>
      <Image src={imgURL} alt={altTag} />
    </Card>
  )
}
DeviceCard.propTypes = {
    imgURL: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    altTag: PropTypes.string.isRequired,
    deviceName: PropTypes.string.isRequired,
    subName: PropTypes.string
}

export default DeviceCard



// WEBPACK FOOTER //
// ./src/components/DeviceCard/index.js